import React from 'react'
import * as Styles from './styles'

type Props = {
  children: JSX.Element
  collapsed: boolean
  style?: object
  title?: string
}

const Section: React.FC<any> = (props: Props) => {
  return (
    <Styles.Container>
      {props.title && <Styles.Title>{props.title}</Styles.Title>}
      {props.children}
    </Styles.Container>
  )
}

export default Section
